export const ports: Record<string, string> = {
  '20': 'FTP Data Transfer',
  '21': 'FTP Control',
  '22': 'SSH',
  '23': 'Telnet',
  '25': 'SMTP',
  '53': 'DNS',
  '80': 'HTTP',
  '110': 'POP3',
  '119': 'NNTP',
  '143': 'IMAP',
  '161': 'SNMP',
  '194': 'IRC',
  '443': 'HTTPS',
  '465': 'SMTPS',
  '587': 'SMTP Submission',
  '636': 'LDAPS',
  '993': 'IMAPS',
  '995': 'POP3S',
  '1433': 'Microsoft SQL Server',
  '1521': 'Oracle DB',
  '1723': 'PPTP',
  '1883': 'MQTT',
  '2049': 'NFS',
  '2055': 'NetFlow',
  '2375': 'Docker (unencrypted)',
  '2376': 'Docker (encrypted)',
  '2480': 'OrientDB',
  '3306': 'MySQL',
  '3389': 'RDP',
  '4040': 'Spark UI',
  '4190': 'Sieve',
  '4369': 'Erlang Port Mapper',
  '5000': 'Docker Registry',
  '5432': 'PostgreSQL',
  '5672': 'AMQP (RabbitMQ)',
  '5900': 'VNC',
  '6080': 'OpenStack Dashboard',
  '6379': 'Redis',
  '6443': 'Kubernetes API',
  '6667': 'IRC (alternative)',
  '7000': 'Cassandra',
  '8000': 'HTTP-alt',
  '8080': 'HTTP-alt',
  '8140': 'Puppet',
  '8443': 'HTTPS-alt',
  '8500': 'Consul',
  '8888': 'Jupyter Notebook',
  '9092': 'Kafka',
  '9200': 'Elasticsearch',
  '10050': 'Zabbix Agent',
  '11211': 'Memcached',
  '27017': 'MongoDB',
  '4444': 'Metasploit ?',
  '5357': 'WSDAPI',
  '5555': 'Android Debug Bridge (ADB)',
  '5985': 'WinRM (HTTP)',
  '5986': 'WinRM (HTTPS)',
  '6000': 'X11 ?',
  '6660': 'DDoS Botnets ?',
  '7001': 'BEA WebLogic',
  '8081': 'Splunkd',
  '9000': 'Hadoop',
};
